export default __webpack_public_path__ + "static/media/cha_medic_shining.187f8ec8.png";